import { Component, Prop, h } from '@stencil/core';
import { Loan } from '../../types';
import { formatNumber } from '../../utils/helpers';

@Component({
  tag: 'kia-loan',
})
export class Priskort {
  @Prop() loan: Loan;

  render() {
    return (
      <div class="kia_price_card--module">
        <h5>
          Billån inkl. serviceavtal
          <kia-tooltip toolTitle="Billån med kontantinsats 30%, 36 mån 4500 mil" />
        </h5>
        <p>Från {formatNumber(this.loan.incl_service_agreement)} kr/mån</p>
        {this.loan.disclaimer && (
          <div class="kia_price_card--disclaimer">
            <p>{this.loan.disclaimer}</p>
          </div>
        )}
      </div>
    );
  }
}
